import { Component, HostBinding, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

interface SvcAlertDialogData {
  text: string;
  title?: string;
  buttonText?: string;
  accentColor?: string;
}

@Component({
  selector: 'svc-alert-dialog',
  templateUrl: './svc-alert-dialog.component.html',
  styleUrls: ['./svc-alert-dialog.component.scss'],
})
export class SvcAlertDialogComponent {
  public title: string;
  public text: string;
  public buttonText: string;
  public accentColor: string;

  @HostBinding('class.svc-alert-dialog') baseClass = true;
  @HostBinding('style.--svc-alert-color') get alertColorVar(): string {
    return this.accentColor;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SvcAlertDialogData,
    private _dialogRef?: MatDialogRef<SvcAlertDialogComponent>
  ) {
    this.accentColor = data?.accentColor ?? '#9a2e23';
    this.title = data?.title ?? 'Alerta';
    this.text = data?.text;
    this.buttonText = data?.buttonText ?? 'OK';
  }

  public closeDialog(): void {
    this._dialogRef.close();
  }
}
